import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Cursor from "@/components/Cursor";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Intro from "@/components/Intro";
import Services from "@/components/Services";
import BeforeAfter from "@/components/BeforeAfter";
import VideoSection from "@/components/VideoSection";
import Panorama from "@/components/Panorama";
import Manifesto from "@/components/Manifesto";
import Workflow from "@/components/Workflow";
import Philosophy from "@/components/Philosophy";
import Marquee from "@/components/Marquee";
import Portfolio from "@/components/Portfolio";
import Pricing from "@/components/Pricing";
import FreeOffer from "@/components/FreeOffer";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ServicePage from "@/pages/ServicePage";
import { SERVICE_PAGES } from "@/data/servicePages";
import { lenisScroll } from "@/lib/scroll";

function Home() {
  useEffect(() => {
    document.title = "VCONTRACTZ — Real Estate Photo Editing & Visual Post-Production Studio";
    const anchor = sessionStorage.getItem("vc-anchor");
    if (anchor) {
      sessionStorage.removeItem("vc-anchor");
      setTimeout(() => lenisScroll(anchor), 450);
    }
  }, []);

  return (
    <main>
      <Hero />
      <TrustStrip />
      <Intro />
      <Services />
      <BeforeAfter />
      <VideoSection />
      <Panorama />
      <Manifesto />
      <Workflow />
      <Philosophy />
      <Marquee />
      <Portfolio />
      <Pricing />
      <FreeOffer />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Contact />
    </main>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="bg-ink text-ivory font-body antialiased" data-testid="app-root">
        <Cursor />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/photo-editing" element={<ServicePage page={SERVICE_PAGES.photo} />} />
          <Route path="/panorama-editing" element={<ServicePage page={SERVICE_PAGES.panorama} />} />
          <Route path="/video-editing" element={<ServicePage page={SERVICE_PAGES.video} />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#151515",
              border: "1px solid rgba(212, 175, 55, 0.3)",
              color: "#F5F2EA",
              borderRadius: 0,
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
